import { render, staticRenderFns } from "./Grabaciones.vue?vue&type=template&id=6f9224cc&scoped=true&"
import script from "./Grabaciones.vue?vue&type=script&lang=js&"
export * from "./Grabaciones.vue?vue&type=script&lang=js&"
import style0 from "./Grabaciones.vue?vue&type=style&index=0&id=6f9224cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9224cc",
  null
  
)

export default component.exports